var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.145,
    height: 28,
    viewBox: "0 0 26.145 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "png_9496407",
    transform: "translate(-16.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186986",
    "data-name": "Group 186986",
    transform: "translate(16.957 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75341",
    "data-name": "Path 75341",
    d: "M107.206,0h9.481l8.372,8.372V24.449A3.562,3.562,0,0,1,121.508,28h-14.3a3.562,3.562,0,0,1-3.551-3.551V3.551A3.562,3.562,0,0,1,107.206,0Z",
    transform: "translate(-98.914 0)",
    fill: "#afaefa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75342",
    "data-name": "Path 75342",
    d: "M341.953,0l8.372,8.372h-7.468a.906.906,0,0,1-.9-.9Z",
    transform: "translate(-324.18 0)",
    fill: "#8987f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75343",
    "data-name": "Path 75343",
    d: "M17.736,218.02H37.02a.782.782,0,0,1,.779.779v7.074a.782.782,0,0,1-.779.779H17.736a.781.781,0,0,1-.779-.779V218.8A.781.781,0,0,1,17.736,218.02Z",
    transform: "translate(-16.957 -206.097)",
    fill: "#6463ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75344",
    "data-name": "Path 75344",
    d: "M86.967,244.4H85.512a.452.452,0,0,0-.452.452v4.842a.452.452,0,0,0,.9,0v-1.419h1a1.909,1.909,0,0,0,1.907-1.907V246.3A1.909,1.909,0,0,0,86.967,244.4Zm1,1.969a1,1,0,0,1-1,1h-1V245.3h1a1,1,0,0,1,1,1Zm5.69-1.517v4.842a.452.452,0,0,1-.84.233l-2.07-3.445v3.212a.452.452,0,0,1-.9,0V244.85a.452.452,0,0,1,.84-.233l2.07,3.445V244.85a.452.452,0,0,1,.9,0Zm4.794,2.645v1.4a1.25,1.25,0,0,1-1.249,1.247H95.888A1.249,1.249,0,0,1,94.64,248.9v-3.25a1.25,1.25,0,0,1,1.247-1.249H97.2a1.25,1.25,0,0,1,1.249,1.249.452.452,0,1,1-.9,0,.345.345,0,0,0-.345-.345H95.888a.349.349,0,0,0-.343.345v3.25a.348.348,0,0,0,.343.343H97.2a.349.349,0,0,0,.345-.343v-.95h-1a.452.452,0,1,1,0-.9H98A.452.452,0,0,1,98.453,247.495Z",
    transform: "translate(-64.379 -231.032)",
    fill: "#d9d7fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.581d270792e6c41a102d2c881cc4dff2.svg";
export { ForwardRef as ReactComponent };